import React from "react";
import "./bottomNav.css";
import { Link } from "react-router-dom";

function BottomNav() {

  return (
    <div class="bottom-nav">
      <Link to="/">
        <div class="nav-slot bg-white round-top-left flex align-center justify-center">
          <div class="nav-link">
            <div className="flex align-center justify-center">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 11.5H16C15.7348 11.5 15.4804 11.6054 15.2929 11.7929C15.1054 11.9804 15 12.2348 15 12.5C15 12.7652 15.1054 13.0196 15.2929 13.2071C15.4804 13.3946 15.7348 13.5 16 13.5H17C17.2652 13.5 17.5196 13.3946 17.7071 13.2071C17.8946 13.0196 18 12.7652 18 12.5C18 12.2348 17.8946 11.9804 17.7071 11.7929C17.5196 11.6054 17.2652 11.5 17 11.5ZM17 15.5H16C15.7348 15.5 15.4804 15.6054 15.2929 15.7929C15.1054 15.9804 15 16.2348 15 16.5C15 16.7652 15.1054 17.0196 15.2929 17.2071C15.4804 17.3946 15.7348 17.5 16 17.5H17C17.2652 17.5 17.5196 17.3946 17.7071 17.2071C17.8946 17.0196 18 16.7652 18 16.5C18 16.2348 17.8946 15.9804 17.7071 15.7929C17.5196 15.6054 17.2652 15.5 17 15.5ZM11 9.5H17C17.2652 9.5 17.5196 9.39464 17.7071 9.20711C17.8946 9.01957 18 8.76522 18 8.5C18 8.23478 17.8946 7.98043 17.7071 7.79289C17.5196 7.60536 17.2652 7.5 17 7.5H11C10.7348 7.5 10.4804 7.60536 10.2929 7.79289C10.1054 7.98043 10 8.23478 10 8.5C10 8.76522 10.1054 9.01957 10.2929 9.20711C10.4804 9.39464 10.7348 9.5 11 9.5ZM21 3.5H7C6.73478 3.5 6.48043 3.60536 6.29289 3.79289C6.10536 3.98043 6 4.23478 6 4.5V7.5H3C2.73478 7.5 2.48043 7.60536 2.29289 7.79289C2.10536 7.98043 2 8.23478 2 8.5V18.5C2 19.2956 2.31607 20.0587 2.87868 20.6213C3.44129 21.1839 4.20435 21.5 5 21.5H18C19.0609 21.5 20.0783 21.0786 20.8284 20.3284C21.5786 19.5783 22 18.5609 22 17.5V4.5C22 4.23478 21.8946 3.98043 21.7071 3.79289C21.5196 3.60536 21.2652 3.5 21 3.5ZM6 18.5C6 18.7652 5.89464 19.0196 5.70711 19.2071C5.51957 19.3946 5.26522 19.5 5 19.5C4.73478 19.5 4.48043 19.3946 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V9.5H6V18.5ZM20 17.5C20 18.0304 19.7893 18.5391 19.4142 18.9142C19.0391 19.2893 18.5304 19.5 18 19.5H7.82C7.93642 19.1793 7.9973 18.8411 8 18.5V5.5H20V17.5ZM11 13.5H12C12.2652 13.5 12.5196 13.3946 12.7071 13.2071C12.8946 13.0196 13 12.7652 13 12.5C13 12.2348 12.8946 11.9804 12.7071 11.7929C12.5196 11.6054 12.2652 11.5 12 11.5H11C10.7348 11.5 10.4804 11.6054 10.2929 11.7929C10.1054 11.9804 10 12.2348 10 12.5C10 12.7652 10.1054 13.0196 10.2929 13.2071C10.4804 13.3946 10.7348 13.5 11 13.5ZM11 17.5H12C12.2652 17.5 12.5196 17.3946 12.7071 17.2071C12.8946 17.0196 13 16.7652 13 16.5C13 16.2348 12.8946 15.9804 12.7071 15.7929C12.5196 15.6054 12.2652 15.5 12 15.5H11C10.7348 15.5 10.4804 15.6054 10.2929 15.7929C10.1054 15.9804 10 16.2348 10 16.5C10 16.7652 10.1054 17.0196 10.2929 17.2071C10.4804 17.3946 10.7348 17.5 11 17.5Z"
                  fill="black"
                />
              </svg>
            </div>
            <p>Home</p>
          </div>
        </div>
      </Link>
      <Link to="/schedule">
      <div class="nav-slot bg-white flex align-center justify-center" >
        <div class="nav-link">
          <div className="flex align-center justify-center">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 4.5H17V3.5C17 3.23478 16.8946 2.98043 16.7071 2.79289C16.5196 2.60536 16.2652 2.5 16 2.5C15.7348 2.5 15.4804 2.60536 15.2929 2.79289C15.1054 2.98043 15 3.23478 15 3.5V4.5H9V3.5C9 3.23478 8.89464 2.98043 8.70711 2.79289C8.51957 2.60536 8.26522 2.5 8 2.5C7.73478 2.5 7.48043 2.60536 7.29289 2.79289C7.10536 2.98043 7 3.23478 7 3.5V4.5H5C4.20435 4.5 3.44129 4.81607 2.87868 5.37868C2.31607 5.94129 2 6.70435 2 7.5V19.5C2 20.2956 2.31607 21.0587 2.87868 21.6213C3.44129 22.1839 4.20435 22.5 5 22.5H19C19.7956 22.5 20.5587 22.1839 21.1213 21.6213C21.6839 21.0587 22 20.2956 22 19.5V7.5C22 6.70435 21.6839 5.94129 21.1213 5.37868C20.5587 4.81607 19.7956 4.5 19 4.5ZM20 19.5C20 19.7652 19.8946 20.0196 19.7071 20.2071C19.5196 20.3946 19.2652 20.5 19 20.5H5C4.73478 20.5 4.48043 20.3946 4.29289 20.2071C4.10536 20.0196 4 19.7652 4 19.5V12.5H20V19.5ZM20 10.5H4V7.5C4 7.23478 4.10536 6.98043 4.29289 6.79289C4.48043 6.60536 4.73478 6.5 5 6.5H7V7.5C7 7.76522 7.10536 8.01957 7.29289 8.20711C7.48043 8.39464 7.73478 8.5 8 8.5C8.26522 8.5 8.51957 8.39464 8.70711 8.20711C8.89464 8.01957 9 7.76522 9 7.5V6.5H15V7.5C15 7.76522 15.1054 8.01957 15.2929 8.20711C15.4804 8.39464 15.7348 8.5 16 8.5C16.2652 8.5 16.5196 8.39464 16.7071 8.20711C16.8946 8.01957 17 7.76522 17 7.5V6.5H19C19.2652 6.5 19.5196 6.60536 19.7071 6.79289C19.8946 6.98043 20 7.23478 20 7.5V10.5Z"
                fill="#364B4B"
              />
            </svg>
          </div>
          <p>Schedule</p>
        </div>
      </div>
      </Link>
      <Link to="/nurse">
        <div class="nav-slot curve ">
          <div class="floating-button pl-[3px] pt-[3px]">
           <img src="/nurse.png" alt="" />
          </div>
        </div>
      </Link>
      <Link to="/community">
        <div class="nav-slot bg-white flex align-center justify-center">
          <div class="nav-link">
            <div className="flex align-center justify-center">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_9_845)">
                  <path
                    d="M5 2.5H19C19.2652 2.5 19.5196 2.60536 19.7071 2.79289C19.8946 2.98043 20 3.23478 20 3.5V22.643C20.0001 22.7324 19.9763 22.8202 19.9309 22.8973C19.8855 22.9743 19.8204 23.0378 19.7421 23.0811C19.6639 23.1244 19.5755 23.1459 19.4861 23.1434C19.3968 23.141 19.3097 23.1146 19.234 23.067L12 18.53L4.766 23.066C4.69037 23.1135 4.60339 23.1399 4.5141 23.1424C4.42482 23.1449 4.33649 23.1235 4.2583 23.0803C4.1801 23.0371 4.11491 22.9738 4.06948 22.8969C4.02406 22.82 4.00007 22.7323 4 22.643V3.5C4 3.23478 4.10536 2.98043 4.29289 2.79289C4.48043 2.60536 4.73478 2.5 5 2.5ZM18 4.5H6V19.932L12 16.171L18 19.932V4.5Z"
                    fill="#4E4B66"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_9_845">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p>Community</p>
          </div>
        </div>
      </Link>
      <Link to="/profile">
      <div class="nav-slot bg-white round-top-right flex align-center justify-center">
        <div class="nav-link">
          <div className="flex align-center justify-center">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_9_848)">
                <path
                  d="M12 22.5C6.477 22.5 2 18.023 2 12.5C2 6.977 6.477 2.5 12 2.5C17.523 2.5 22 6.977 22 12.5C22 18.023 17.523 22.5 12 22.5ZM7.013 18.756C8.42855 19.8877 10.1877 20.5029 12 20.5C13.97 20.5 15.773 19.788 17.167 18.608C16.5157 17.9397 15.7371 17.4089 14.877 17.0468C14.017 16.6847 13.0931 16.4988 12.16 16.5C11.1926 16.4989 10.2355 16.6989 9.34947 17.0872C8.46343 17.4756 7.66778 18.0439 7.013 18.756ZM5.616 17.32C6.45645 16.4281 7.47067 15.7177 8.59614 15.2327C9.72161 14.7477 10.9345 14.4984 12.16 14.5C13.3417 14.4985 14.512 14.7304 15.6037 15.1824C16.6955 15.6344 17.6873 16.2976 18.522 17.134C19.3781 15.9291 19.8836 14.5106 19.9826 13.0359C20.0815 11.5612 19.77 10.0879 19.0825 8.77946C18.395 7.47102 17.3585 6.37862 16.088 5.62345C14.8174 4.86827 13.3625 4.47984 11.8846 4.50125C10.4067 4.52267 8.96366 4.95308 7.71552 5.74476C6.46738 6.53643 5.46296 7.6584 4.81369 8.9862C4.16442 10.314 3.89569 11.7957 4.03732 13.2669C4.17894 14.7382 4.72537 16.1414 5.616 17.321V17.32ZM12 13.5C10.9391 13.5 9.92172 13.0786 9.17157 12.3284C8.42143 11.5783 8 10.5609 8 9.5C8 8.43913 8.42143 7.42172 9.17157 6.67157C9.92172 5.92143 10.9391 5.5 12 5.5C13.0609 5.5 14.0783 5.92143 14.8284 6.67157C15.5786 7.42172 16 8.43913 16 9.5C16 10.5609 15.5786 11.5783 14.8284 12.3284C14.0783 13.0786 13.0609 13.5 12 13.5ZM12 11.5C12.5304 11.5 13.0391 11.2893 13.4142 10.9142C13.7893 10.5391 14 10.0304 14 9.5C14 8.96957 13.7893 8.46086 13.4142 8.08579C13.0391 7.71071 12.5304 7.5 12 7.5C11.4696 7.5 10.9609 7.71071 10.5858 8.08579C10.2107 8.46086 10 8.96957 10 9.5C10 10.0304 10.2107 10.5391 10.5858 10.9142C10.9609 11.2893 11.4696 11.5 12 11.5Z"
                  fill="#4E4B66"
                />
              </g>
              <defs>
                <clipPath id="clip0_9_848">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <p>Profile</p>
        </div>
      </div>
      </Link>
    </div>
  );
}

export default BottomNav;
